// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"9971e483","129":"4165f3bc","391":"a5973fea","584":"4d995b1e","950":"22da05f2"}[chunkId] + ".chunk.js";
};